import { c as _c } from "react/compiler-runtime";
import { useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Search, FileText, Lock, ExternalLink, ChevronDown } from "lucide-react";
import Link from "next/link";
import { REPORTS_DB, REPORT_FILTERS } from "@/data/reportsData";
const ReportExplorer = () => {
  const $ = _c(43);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeCountry, setActiveCountry] = useState("All Countries");
  const [activeType, setActiveType] = useState("All Types");
  const [activeAccess, setActiveAccess] = useState("All Access");
  const [showFilters, setShowFilters] = useState(false);
  let t0;
  if ($[0] !== activeAccess || $[1] !== activeCountry || $[2] !== activeType || $[3] !== searchTerm) {
    t0 = REPORTS_DB.filter(report => {
      const matchesCountry = activeCountry === "All Countries" || report.country === activeCountry;
      const matchesType = activeType === "All Types" || report.type === activeType;
      const matchesAccess = activeAccess === "All Access" || report.access === activeAccess;
      const matchesSearch = report.title.toLowerCase().includes(searchTerm.toLowerCase()) || report.author.toLowerCase().includes(searchTerm.toLowerCase()) || report.organization.toLowerCase().includes(searchTerm.toLowerCase()) || report.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
      return matchesCountry && matchesType && matchesAccess && matchesSearch;
    });
    $[0] = activeAccess;
    $[1] = activeCountry;
    $[2] = activeType;
    $[3] = searchTerm;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const filteredReports = t0;
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => setSearchTerm(e.target.value);
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== searchTerm) {
    t2 = <input type="text" placeholder="Search by title, author, organization, or keyword..." value={searchTerm} onChange={t1} className="w-full bg-[#F4EFE6] border border-[#0F1C2E]/15 px-4 py-3 sm:py-3.5 pl-10 sm:pl-11 font-body text-[12px] sm:text-[13px] outline-none focus:border-[#DF6D2A] transition-colors" />;
    $[6] = searchTerm;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#0F1C2E]/30" size={16} />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2) {
    t4 = <div className="relative flex-1">{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== showFilters) {
    t5 = () => setShowFilters(!showFilters);
    $[11] = showFilters;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = showFilters ? 180 : 0;
  let t7;
  if ($[13] !== t6) {
    t7 = {
      rotate: t6
    };
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      duration: 0.2
    };
    t9 = <ChevronDown size={14} />;
    $[15] = t8;
    $[16] = t9;
  } else {
    t8 = $[15];
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7) {
    t10 = <motion.span animate={t7} transition={t8}>{t9}</motion.span>;
    $[17] = t7;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t5) {
    t11 = <button onClick={t5} className="font-body text-[10px] sm:text-[11px] tracking-[0.1em] sm:tracking-[0.15em] uppercase px-4 sm:px-6 py-3 sm:py-3.5 border border-[#0F1C2E]/15 flex items-center gap-2 hover:bg-[#0F1C2E] hover:text-white transition-colors whitespace-nowrap">Advanced Filters{t10}</button>;
    $[19] = t10;
    $[20] = t5;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t4) {
    t12 = <div className="flex flex-col md:flex-row gap-4 items-stretch md:items-center">{t4}{t11}</div>;
    $[22] = t11;
    $[23] = t4;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== activeAccess || $[26] !== activeCountry || $[27] !== activeType || $[28] !== showFilters) {
    t13 = showFilters && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="overflow-hidden"><div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 pt-6 border-t border-[#0F1C2E]/10"><div><label className="font-body text-[9px] tracking-[0.2em] uppercase text-[#4C596B] block mb-2">Country</label><select value={activeCountry} onChange={e_0 => setActiveCountry(e_0.target.value)} className="w-full bg-[#F4EFE6] border border-[#0F1C2E]/15 px-4 py-3 font-body text-[13px] outline-none appearance-none cursor-pointer focus:border-[#DF6D2A]">{REPORT_FILTERS.countries.map(_temp)}</select></div><div><label className="font-body text-[9px] tracking-[0.2em] uppercase text-[#4C596B] block mb-2">Report Type</label><select value={activeType} onChange={e_1 => setActiveType(e_1.target.value)} className="w-full bg-[#F4EFE6] border border-[#0F1C2E]/15 px-4 py-3 font-body text-[13px] outline-none appearance-none cursor-pointer focus:border-[#DF6D2A]">{REPORT_FILTERS.types.map(_temp2)}</select></div><div><label className="font-body text-[9px] tracking-[0.2em] uppercase text-[#4C596B] block mb-2">Access Level</label><select value={activeAccess} onChange={e_2 => setActiveAccess(e_2.target.value)} className="w-full bg-[#F4EFE6] border border-[#0F1C2E]/15 px-4 py-3 font-body text-[13px] outline-none appearance-none cursor-pointer focus:border-[#DF6D2A]">{REPORT_FILTERS.access.map(_temp3)}</select></div></div></motion.div>;
    $[25] = activeAccess;
    $[26] = activeCountry;
    $[27] = activeType;
    $[28] = showFilters;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13) {
    t14 = <AnimatePresence>{t13}</AnimatePresence>;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t12 || $[33] !== t14) {
    t15 = <div className="bg-white border border-[#0F1C2E]/10 p-4 sm:p-6 md:p-8 mb-8 sm:mb-12 shadow-sm">{t12}{t14}</div>;
    $[32] = t12;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== filteredReports.length) {
    t16 = <div className="flex items-center justify-between mb-5 sm:mb-8"><p className="font-body text-[13px] text-[#4C596B]">Showing <span className="text-[#0F1C2E] font-semibold">{filteredReports.length}</span> reports</p></div>;
    $[35] = filteredReports.length;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== filteredReports) {
    t17 = filteredReports.length === 0 ? <div className="text-center py-16 sm:py-24 md:py-32 border border-dashed border-[#0F1C2E]/20 bg-white"><FileText className="mx-auto mb-4 text-[#0F1C2E]/20" size={36} /><p className="font-display text-[20px] sm:text-[24px] text-[#4C596B] mb-2">No reports match your criteria.</p><p className="font-body text-[13px] text-[#4C596B]/60">Try broadening your filters or adjusting search terms.</p></div> : <div className="flex flex-col gap-4 sm:gap-6"><AnimatePresence>{filteredReports.map(_temp5)}</AnimatePresence></div>;
    $[37] = filteredReports;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t15 || $[40] !== t16 || $[41] !== t17) {
    t18 = <section className="bg-[#F4EFE6] py-12 sm:py-16 md:py-24 relative min-h-screen"><div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12">{t15}{t16}{t17}</div></section>;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
};
export default ReportExplorer;
function _temp(c) {
  return <option key={c} value={c}>{c}</option>;
}
function _temp2(t) {
  return <option key={t} value={t}>{t}</option>;
}
function _temp3(a) {
  return <option key={a} value={a}>{a}</option>;
}
function _temp4(tag_0) {
  return <span key={tag_0} className="font-body text-[9px] tracking-wider uppercase text-[#4C596B] border border-[#0F1C2E]/10 px-2 py-0.5">{tag_0}</span>;
}
function _temp5(report_0, idx) {
  return <motion.div key={report_0.id} layout={true} initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -10
  }} transition={{
    duration: 0.3,
    delay: idx * 0.05
  }}><Link href={`/reports/${report_0.slug}`} className="block group"><div className="bg-white border border-[#0F1C2E]/10 p-5 sm:p-6 md:p-8 lg:p-10 hover:shadow-[0_10px_40px_rgba(15,28,46,0.08)] transition-all duration-500 flex flex-col md:flex-row md:items-start gap-4 sm:gap-6 md:gap-8"><div className="shrink-0 w-full sm:w-[100px] flex flex-row sm:flex-col items-center sm:items-center gap-2 sm:gap-0 border border-[#0F1C2E]/10 p-3 sm:p-4 bg-[#F4EFE6]"><span className="font-display text-[28px] sm:text-[36px] leading-none text-[#0F1C2E]">{report_0.year}</span><span className="font-body text-[8px] tracking-[0.2em] uppercase text-[#DF6D2A] mt-1">{report_0.country}</span></div><div className="flex-1"><div className="flex flex-wrap items-center gap-3 mb-3"><span className="font-body text-[9px] tracking-[0.15em] uppercase px-2.5 py-1 bg-[#0F1C2E] text-white">{report_0.type}</span><span className={`font-body text-[9px] tracking-[0.15em] uppercase px-2.5 py-1 border flex items-center gap-1.5 ${report_0.access === "Open Access" ? "border-green-600/30 text-green-700" : "border-red-500/30 text-red-600"}`}>{report_0.access === "Open Access" ? <FileText size={10} /> : <Lock size={10} />}{report_0.access}</span></div><h3 className="font-display text-[20px] sm:text-[24px] md:text-[26px] lg:text-[32px] leading-[1.15] text-[#0F1C2E] group-hover:text-[#DF6D2A] transition-colors mb-2 sm:mb-3">{report_0.title}</h3><p className="font-body text-[12px] sm:text-[13px] text-[#4C596B] mb-3 sm:mb-4"><span className="font-semibold">{report_0.author}</span> — {report_0.organization}</p><p className="font-body text-[13px] sm:text-[14px] text-[#4C596B]/80 leading-[1.6] sm:leading-[1.7] line-clamp-2">{report_0.abstract}</p><div className="flex flex-wrap gap-1.5 sm:gap-2 mt-3 sm:mt-5">{report_0.tags.map(_temp4)}</div></div><div className="shrink-0 hidden md:flex flex-col items-center gap-3 self-center"><div className="w-12 h-12 rounded-full border border-[#0F1C2E]/20 flex items-center justify-center group-hover:bg-[#DF6D2A] group-hover:border-[#DF6D2A] transition-all duration-500 overflow-hidden relative"><span className="absolute text-[#0F1C2E] group-hover:text-white transition-transform duration-500 group-hover:translate-x-6 group-hover:-translate-y-6"><ExternalLink size={16} /></span><span className="absolute text-white -translate-x-6 translate-y-6 transition-transform duration-500 group-hover:translate-x-0 group-hover:translate-y-0"><ExternalLink size={16} /></span></div><span className="font-body text-[9px] uppercase tracking-widest text-[#4C596B] opacity-0 group-hover:opacity-100 transition-opacity">View</span></div></div></Link></motion.div>;
}